import axios from "axios";
import { config } from "./conf";
import { requestHeaders } from "./http";

export async function fetchUserProfile(accessToken, jwtUser) {
  const userId = jwtUser?.id;

  if (!userId) {
    return jwtUser;
  }

  try {
    const response = await axios.get(
      `${config.authenticationApiUrl}/v1/users/${userId}`,
      {
        headers: requestHeaders(accessToken),
      },
    );

    return response?.data || jwtUser;
  } catch (err) {
    return jwtUser;
  }
}
